module.exports = "/img/about-gallery-5.97a0e588.png";